// Campanita de solicitudes de devolucion (usuarios de matriz).
//   total:        solicitudes PENDIENTE segun el API (carga inicial + tras resolver) + pushes recibidos
//   recientes:    ultimos avisos recibidos por push en ESTA sesion de pestana (mas nuevo primero)
//   noVistas:     avisos recibidos desde la ultima vez que se abrio la campanita / Autorizar
//   ultimoAviso:  el push mas reciente (dispara el snackbar y el auto-refresh de Autorizar); null al cerrarlo
//   tokenWeb:     token FCM registrado en el API ('' si no hay), tokenEstado: 'pendiente'|'registrado'|'no_disponible'
const MAX_RECIENTES = 20;

const initState = {
    total: null,
    recientes: [],
    noVistas: 0,
    ultimoAviso: null,
    tokenWeb: "",
    tokenEstado: "pendiente",
    notif_Error_Message: null,
};

const notificacionesReducer = (state = initState, action) => {
    switch (action.type) {
        case "NOTIF_TOTAL_SUCCESS":
            return {
                ...state,
                total: parseInt(action.payload.total, 10) || 0,
                notif_Error_Message: null,
            };
        case "NOTIF_NUEVA_SOLICITUD": {
            const s = action.payload.solicitud;
            // un reenvio del mismo aviso (mismo id) no duplica ni vuelve a contar
            const yaEstaba = s.id > 0 && state.recientes.some((r) => r.id === s.id);
            if (yaEstaba) {
                return { ...state, ultimoAviso: s };
            }
            return {
                ...state,
                total: (state.total || 0) + 1,
                recientes: [s].concat(state.recientes).slice(0, MAX_RECIENTES),
                noVistas: state.noVistas + 1,
                ultimoAviso: s,
            };
        }
        case "NOTIF_MARCAR_VISTAS":
            return { ...state, noVistas: 0 };
        case "NOTIF_CERRAR_AVISO":
            return { ...state, ultimoAviso: null };
        case "NOTIF_TOKEN_REGISTRADO":
            return { ...state, tokenWeb: action.payload.token, tokenEstado: "registrado" };
        case "NOTIF_TOKEN_NO_DISPONIBLE":
            return { ...state, tokenWeb: "", tokenEstado: "no_disponible" };
        case "NOTIF_TOKEN_ELIMINADO":
            return { ...state, tokenWeb: "", tokenEstado: "pendiente" };
        case "NOTIF_ERROR":
            return { ...state, notif_Error_Message: action.payload.error };
        case "NOTIF_CLOSE_MESSAGES":
            return { ...state, notif_Error_Message: null };
        default:
            return state;
    }
};

export default notificacionesReducer;
